export class TreeModel {
    title = '';
    key = '';
    children = new Array<TreeModel>();
    isLeaf: boolean;
    parentId: '';
    code: '';
    description: '';
}
